import { combineReducers } from 'core/redux'

import customProfile from '../customProfile'
import emailMarketing from '../emailMarketing'
import github from '../github'
import jiraCloud from '../jiraCloud'
import jiraServer from '../jiraServer'
import trello from '../trello'
import credentials from './credentials'
import hubspot from '../hubspot/reducers'
import recentConversations from '../recentConversations/reducers'
import salesforce from '../salesforce/reducers'
import shopify from '../shopify'

export default combineReducers({
  credentials,
  emailMarketing,
  recentConversations,
  thirdPartyData: combineReducers({
    customProfile,
    github,
    jiraCloud,
    jiraServer,
    trello,
    hubspot,
    salesforce,
    shopify,
  }),
})
